import React, { useState } from 'react'
import { useLocation } from 'react-router'

import { useCartQuantityHandling } from 'components/ProductCartControls/utils'
import GenericQuantityControls, {
  CONTROLS_VARIANT,
} from 'components/ProductCartControls/QuantityControls'
import { getCartUnitsOfMeasure } from 'views/CartV2/utils'

const QuantityControls = ({ item }) => {
  const location = useLocation()

  const { product } = item

  const unitsOfMeasure = getCartUnitsOfMeasure(item)
  const unitData = unitsOfMeasure[0] // TODO: add support for multiple units of measure

  const [inputQuantity, setInputQuantity] = useState(unitData.inCartQuantity)
  const [isInputDisabled, setInputDisabled] = useState(false)
  const changeCartQuantity = useCartQuantityHandling({
    product: {
      ...product,
      unitsOfMeasure,
    },
    unitData,
    attributionToken: location.state?.attributionToken,
    beforeAll: () => setInputDisabled(true),
    afterAll: () => setInputDisabled(false),
    resetQuantityCallback: () => setInputQuantity(unitData.inCartQuantity),
    onChangeAmountToStock: () => setInputQuantity(unitData.inCartQuantity),
  })

  const handleQuantityChange = (value, dispatchParams) => {
    if (value === 0 || unitData.inCartQuantity === 0) {
      setInputDisabled(true)
    }

    setInputQuantity(value)

    if (value !== unitData.inCartQuantity) {
      changeCartQuantity(value, dispatchParams)
    }
  }

  return (
    <GenericQuantityControls
      quantity={inputQuantity}
      disabled={isInputDisabled}
      product={product}
      unitData={unitData}
      onQuantityChange={handleQuantityChange}
      variant={CONTROLS_VARIANT.DARK_BLUE}
    />
  )
}

export default QuantityControls
